// import { QueryClient, QueryClientProvider } from "react-query"

import ProtectedRoute from "ProtectedRoute"
// ...existing code...
import Card from "components/Card"
import EmptyState from "components/EmptyState"
import ToastProvider from "components/toast/ToastProvider"
import { SentryUserContext } from "components/SentryUserContext"
import Page404 from "features/layout/Page404"
import Newsletter from "features/newsletter/Newsletter"
import Offer from "features/offers/Offer"
import OfferEmptyState from "features/offers/OfferEmptyState"
import Offers from "features/offers/Offers"
import OffersPdf from "features/offersPdf/OffersPdf"
import Post from "features/offersPost/Post"
import Signature from "features/signature/Signature"
import type { FC } from "react"
import { Trans } from "react-i18next"
import { Route, Routes } from "react-router-dom"
import Layout from "./features/layout/Layout"

const App: FC = () => {
  return (
    <div className="App">
      <ToastProvider>
        <ProtectedRoute>
          <SentryUserContext />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route path="offers" element={<Offers />}>
                <Route
                  index
                  element={
                    <Card title={<Trans i18nKey="offers.title" />}>
                      <EmptyState padding="md">
                        <Trans i18nKey="offers.empty.selectOffer" />
                      </EmptyState>
                    </Card>
                  }
                />
                <Route path=":offerId" element={<Offer />}>
                  <Route index element={<OfferEmptyState />} />
                  <Route path="post" element={<Post />} />
                  <Route path="pdf" element={<OffersPdf />} />
                </Route>
              </Route>
              <Route path="newsletter" element={<Newsletter />} />
              <Route path="signature" element={<Signature />} />
              <Route path="*" element={<Page404 />} />
            </Route>
          </Routes>
        </ProtectedRoute>
      </ToastProvider>
    </div>
  )
}

export default App
